import { Component, inject, Input } from '@angular/core';

import { EcmMaterialModule } from '@ecm/material';
import { EcmRouterModule, ExtendedLinkService } from '@ecm/router';

import { ContractV7Offer } from '../../../business/api/dashboardV7/contract/contractV7Offer';
import { PushV7 } from '../../../business/api/dashboardV7/pushV7';

@Component({
    selector: 'push-change-offer',
    templateUrl: 'push-change-offer.component.html',
    styleUrls: ['push-change-offer.component.css'],
    standalone: true,
    imports: [EcmMaterialModule, EcmRouterModule],
})
export class PushChangeOfferComponent {
    public extendedLinkService = inject(ExtendedLinkService);

    @Input()
    public changeOffer!: PushV7;
    @Input()
    public isDisabledEclair: any;
    @Input()
    public zid!: string;
    @Input()
    public offer!: ContractV7Offer;
}
